var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    className: "mr4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.607 2.704c-2.395 0-4.334 1.951-4.334 4.355 0 2.404 1.939 4.355 4.333 4.355 2.395 0 4.334-1.951 4.334-4.355 0-2.404-1.939-4.355-4.334-4.355zm0 2c1.287 0 2.333 1.053 2.333 2.355S9.894 9.414 8.606 9.414c-1.287 0-2.333-1.053-2.333-2.355s1.046-2.355 2.334-2.355z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.273 6.059a1 1 0 01.136 1.991l-.136.01H2.055a1.001 1.001 0 01-.136-1.992l.136-.009h3.218zm16.872 0c.448 0 .812.448.812 1 0 .506-.306.925-.702.991l-.11.01h-9.898c-.449 0-.813-.449-.813-1 0-.507.306-.925.702-.992l.11-.009h9.898zM15.395 12.587c2.394 0 4.333 1.95 4.333 4.355 0 2.403-1.939 4.355-4.333 4.355-2.395 0-4.334-1.952-4.334-4.355 0-2.404 1.939-4.356 4.334-4.356zm0 2a2.344 2.344 0 00-2.334 2.355 2.345 2.345 0 002.334 2.355 2.344 2.344 0 002.333-2.355 2.344 2.344 0 00-2.333-2.356z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.728 15.942a1 1 0 00-.135 1.99l.135.01h3.219a1 1 0 00.136-1.991l-.136-.01h-3.218zM1.856 15.942c-.449 0-.812.447-.812 1 0 .506.305.924.702.99l.11.01h9.896c.448 0 .812-.448.812-1 0-.507-.305-.925-.702-.991l-.11-.01H1.855z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.ac28647449c2faaf9e0ad83a7522b2e2.svg";
export { ForwardRef as ReactComponent };